import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import 'moment/locale/ru';

export default class MaterialCard extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        // eslint-disable-next-line
        publishTime: PropTypes.object.isRequired,
        // eslint-disable-next-line
        cover: PropTypes.any,
        className: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className={`news--card ${this.props.className}`}>
                <a href={this.props.href}>
                    <span className="material--info">
                        <span className="info--title">{this.props.title}</span>
                        <span className="info--date">{moment(this.props.publishTime.sec * 1000).format('D MMMM YYYY г., H:mm')}</span>
                    </span>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Materials/NewsCard.jsx